import script from "./CustomerRequestModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerRequestModal.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerRequestModal.vue?vue&type=style&index=0&id=a4f43e28&lang=scss"

const __exports__ = script;

export default __exports__